import React, { useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';

import FormGDPR from '../Form';

interface GDPR {
  title: string;
  text: string;
  company: string;
  textFootnote: string;
  textLinkFootnote: string;
  defaultLanguageId: number;
  translationLanguageId: number;
  textTranslated: string;
  textFootnoteTranslated: string;
  textLinkFootnoteTranslated: string;
}

const CreateGDPR: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (data: GDPR) => {
      try {
        formRef.current?.setErrors({});

        const translations = [
          {
            text: data.textTranslated,
            languageId: data.translationLanguageId,
            textFootnote: data.textFootnoteTranslated,
            textLinkFootnote: data.textLinkFootnoteTranslated,
          },
        ];

        const gdprInsert = {
          translations,
          title: data.title,
          text: data.text,
          defaultLanguageId: data.defaultLanguageId,
          textFootnote: data.textFootnote,
          textLinkFootnote: data.textLinkFootnote,
        };

        const schema = Yup.object().shape({
          title: Yup.string().required('The title is required'),
          text: Yup.string().required('The text required'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/gdpr', gdprInsert);

        const redirectUrl = '/gdpr';

        navigate(redirectUrl);

        addToast({
          type: 'success',
          title: 'Success',
          description: 'The text was created successfully!',
        });
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Registration Error',
          description:
            'An error occurred while creating the text, please try again.',
        });
      }
    },
    [addToast, navigate],
  );

  return (
    <>
      <h1>New GDPR</h1>

      <FormGDPR
        formRef={formRef}
        handleSubmit={handleSubmit}
        buttonText="Create"
      />
    </>
  );
};

export default CreateGDPR;
